module.exports = __webpack_public_path__ + "img/logo-verloskundige-pijnacker.06b7a99e.webp";